/* eslint-disable no-underscore-dangle */
const baseUrl = window.__ENV__.BASE_URL;
const sentryUrl = window.__ENV__.SENTRY_URL;
const minioUrl = window.__ENV__.MINIO_URL;
const googleMapsApiKey = window.__ENV__.GOOGLE_MAPS_API_KEY;
const publicVapidKey = window.__ENV__.PUBLIC_VAPID_KEY;
const generateTestId = window.__ENV__.GENERATE_TEST_ID;

const appSettings = {
  baseUrl,
  sentryUrl,
  apiBaseUrl: baseUrl,
  minioBaseUrl: minioUrl,
  googleMapsApiKey,
  publicVapidKey,
  authCookieName: ".tuli-uiLoggedIn",
  languageCookieName: ".tuli-uiLanguage",
  generateTestId,
};

export default appSettings;
